import { Button } from '@mui/material';
import { INode } from '../../NewFormBuilder/Context/FormBuilderContext';
import { usePublishedForm } from '../Context/PublishedFormContext';

interface SubmitProps {
  node: INode;
}

export function Submit({ node }: SubmitProps) {
  const { handleSubmitForm, isUploading } = usePublishedForm();
  const styles = node.data.styles;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: styles.submit?.textAlign
          ? styles.submit?.textAlign
          : 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Button
        variant="contained"
        color="primary"
        disabled={isUploading}
        sx={{
          backgroundColor: isUploading
            ? '#9CA3AF'
            : styles?.submit?.buttonBackgroundColor || '#3650DE',
          '&:hover': {
            backgroundColor: isUploading
              ? '#9CA3AF'
              : styles?.submit?.buttonBackgroundColor || '#2A3F9E',
            opacity: isUploading ? '1' : '0.8',
            boxShadow: 'none',
          },
          color: styles?.submit?.color || '#ffffff',
          fontFamily: styles?.submit?.fontFamily || 'Roboto, sans-serif',
          fontSize: `${styles?.submit?.fontSize || 16}px`,
          fontWeight: styles?.submit?.isBold ? '700' : '400',
          fontStyle: styles?.submit?.isItalic ? 'italic' : 'normal',
          textDecoration: styles?.submit?.isUnderlined ? 'underline' : 'none',
          padding: '8px 16px',
          height: '100%',
          boxShadow: 'none',
          cursor: isUploading ? 'not-allowed' : 'pointer',
        }}
        onClick={handleSubmitForm}
      >
        SUBMIT
      </Button>
    </div>
  );
}
